import { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ApplicationState } from "@idw-types/state/application-state";
import { refreshAxnAdminLoggingReduxRequest } from "@redux-requests/axn-admin-logging";
import { ButtonWithSpinner } from "../../common/button-with-spinner/button-with-spinner";
import { ContentPageHeader } from "../../common/content-page-header/content-page-header";
import { LoadingIndicator } from "../../common/loading-indicator/loading-indicator";
import { RefreshResultsContainer } from "../refresh-results-container/refresh-results-container";
import { CardContainer } from "../../common/card-container/card-container";
import { resources } from "@constants/hardcoded-strings";
import { ContentPageBody } from "../../common/content-page-body/content-page-body";
import { ButtonTypes } from "@enums/button-types";

export const AxnAdminLoggingContainer = () => {
    const dispatch = useDispatch();
    const { isRefreshing, refreshResults, lastRefreshDate } = useSelector((state: ApplicationState) => ({
        isRefreshing: state.axnAdminLogging.isRefreshing,
        refreshResults: state.axnAdminLogging.refreshResults,
        lastRefreshDate: state.axnAdminLogging.lastRefreshDate
    }));

    const onClickRefreshLogging = () => {
        refreshAxnAdminLoggingReduxRequest(dispatch)();
    };

    const headerButton = useMemo(() => {
        return (
            <ButtonWithSpinner
                id="axn-admin-refresh-logging-button"
                onClick={onClickRefreshLogging}
                disabled={isRefreshing}
                variant="primary"
                label={resources.common.buttons.refresh.label}
                type={ButtonTypes.BUTTON}
            />
        );
    }, [isRefreshing]);

    return (
        <CardContainer>
            <ContentPageHeader title={resources.pages.axnAdminLogging.header} headerButton={headerButton} />
            <ContentPageBody isMaxWidth={true}>
                {!isRefreshing && refreshResults && (
                    <RefreshResultsContainer refreshResults={refreshResults} lastRefreshDate={lastRefreshDate} />
                )}
                {isRefreshing && (
                    <LoadingIndicator title={resources.pages.axnAdminLogging.loadingIndicatorText} />
                )}
            </ContentPageBody>
        </CardContainer>
    );
};